(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["solis-video-gallery"] && !Shopify.designMode) return;
  try {
    class SolisVideoGallery {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-vg-track]');
      this.modal = root.querySelector('[data-vg-modal]');
      this.player = root.querySelector('[data-vg-player]');
      if (!this.track || !this.modal || !this.player) return;

      for (const btn of root.querySelectorAll('[data-vg-scroll]')) {
        btn.addEventListener('click', () => {
          this.track.scrollBy({ left: this.track.clientWidth * 0.85 * Number(btn.dataset.vgScroll), behavior: 'smooth' });
        });
      }

      for (const card of root.querySelectorAll('[data-vg-card]')) {
        card.addEventListener('click', () => this.open(card));
      }

      for (const btn of root.querySelectorAll('[data-vg-close]')) {
        btn.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.modal.hidden) this.close();
      });

      // Previews only run while on screen — off-screen cards cost nothing.
      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          const v = e.target.querySelector('video');
          if (!v) continue;
          // No autoplay attribute: the browser would download every preview on load.
          if (e.isIntersecting) { v.dataset.vgVisible = '1'; v.play().catch(() => {}); }
          else { delete v.dataset.vgVisible; v.pause(); }
        }
      }, { rootMargin: '150px' });
      for (const card of root.querySelectorAll('[data-vg-card]')) io.observe(card);
    }

    open(card) {
      const src = card.querySelector('video source, video')?.src
        || card.querySelector('video source')?.getAttribute('src');
      if (!src) return;

      for (const v of this.root.querySelectorAll('.solis-vg__card video')) v.pause();

      const full = document.createElement('video');
      full.controls = true;
      full.autoplay = true;
      full.playsInline = true;
      full.src = src;
      this.player.replaceChildren(full);
      this.modal.hidden = false;
      this.trigger = card;
      this.root.querySelector('.solis-vg__close')?.focus();
      // Inside the click gesture, so sound is allowed to start.
      full.play().catch(() => {});
    }

    close() {
      const v = this.player.querySelector('video');
      if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
      this.player.replaceChildren();
      this.modal.hidden = true;
      for (const pv of this.root.querySelectorAll('.solis-vg__card video')) if (pv.dataset.vgVisible) pv.play().catch(() => {});
      this.trigger?.focus();
    }
  }

  const initVg = (root = document) => {
    for (const el of root.querySelectorAll('[data-solis-vg]:not([data-vg-ready])')) {
      el.dataset.vgReady = '';
      new SolisVideoGallery(el);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVg());
  } else {
    initVg();
  }
  document.addEventListener('shopify:section:load', (e) => initVg(e.target));
  } catch(e) { console.error(e); }
})();

})();
